// polyfill for the MouseEvent() constructor functionality
// in Internet Explorer 9 and higher
// from https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent

(function (window) {
  try {
    new MouseEvent('test');
    return false; // No need to polyfill
  } catch (e) {
    // Need to polyfill - fall through
    // eslint-disable-line no-unused-vars
  }

  // Polyfills DOM4 MouseEvent

  const MouseEvent = function (eventType, params = {}) {
    params.bubbles = params.bubbles || false;
    params.cancelable = params.cancelable || false;
    params.clientX = params.clientX || 0;
    params.clientY = params.clientY || 0;

    const mouseEvent = document.createEvent('MouseEvent');

    mouseEvent.initMouseEvent(
      eventType,
      params.bubbles,
      params.cancelable,
      window, // view
      0, // detail
      0, // screenX
      0, // screenY
      params.clientX,
      params.clientY,
      false,
      false,
      false,
      false,
      0,
      null
    );

    return mouseEvent;
  };

  MouseEvent.prototype = Event.prototype;

  window.MouseEvent = MouseEvent;
})(window);



// WEBPACK FOOTER //
// ./_polyfill/mouse-event.js